<template>
    <h4 class="mb-2">Welcome to safeworkpro!</h4>
    <p class="mb-4">Please sign-in to your account</p>
    <form class="mb-3" @submit.prevent="handleLogin">
        <div class="mb-3">
            <label for="email" class="form-label">Email</label>
            <input type="text" class="form-control" id="email"  placeholder="Enter your email" v-model="email"  required autofocus />
        </div>
        <div class="mb-3 form-password-toggle">
            <div class="d-flex justify-content-between">
                <label class="form-label" for="password">Password</label>
                <a href="/forgot"><small>Forgot Password?</small></a>
            </div>
            <div class="input-group input-group-merge">
                <input :type="showPassword ? 'text' : 'password'" id="password" class="form-control" placeholder="&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;" aria-describedby="password" v-model="password" required />
                <span class="input-group-text cursor-pointer"><i :class="showPassword ? 'bx bx-hide' : 'bx bx-show'" @click="togglePassword"></i></span>
            </div>
        </div>
        <div class="mb-3">
            <div class="form-check">
            <input class="form-check-input" type="checkbox" id="remember-me" />
            <label class="form-check-label" for="remember-me"> Remember Me </label>
            </div>
        </div>
        <div class="mb-3">
            <button class="btn btn-info d-grid w-100" type="submit">Sign in</button>
        </div>

        <div v-if="errorMessage" class="alert alert-danger mt-3" role="alert">
            Invalid credentials. Please try again.
        </div>
    </form>

    <p class="text-center">
        <span>Don't have an account?</span> <router-link to="/register">Create an account</router-link>
    </p>
</template>

<script>
    import axios from 'axios';
    export default {
        data() {
            return {
                email: '',
                password: '',
                showPassword: false,
                errorMessage: false
            };
        },
        methods: {
            togglePassword() {
                this.showPassword = !this.showPassword;
            },
            async handleLogin() {

                try {
                    const response = await axios.post('/auth/login', {
                        email: this.email,
                        password: this.password
                    }, { withCredentials: true }); // important for sessions
                    let data = response.data;
                    let user = data.user;
                    localStorage.setItem('user', user.email);
                    localStorage.setItem('email', user.email);
                    localStorage.setItem('customerId', user.customerId);
                    localStorage.setItem('firstName', user.firstName);
                    localStorage.setItem('lastName', user.lastName);
                    localStorage.setItem('website', user.website);
                    localStorage.setItem('companyName', user.companyName);
                    
                    
                    this.$emit('updateMembershipStatus');
                    this.$router.push("/dashboard");
                } catch (err) {
                    this.message = err.response?.data || 'Login failed';
                }
            },
        },
    };
</script>

<style>
    
</style>
